import { useVnGoldPrices } from '@/hooks/useVnGoldPrices';

interface TickerItemProps {
  name: string;
  code: string;
  sell: number;
  changePercent: number;
}

function TickerItem({ name, code, sell, changePercent }: TickerItemProps) {
  const isUp = changePercent >= 0;
  return (
    <div className="inline-flex items-center gap-3 px-5 shrink-0">
      <div className="w-6 h-6 rounded bg-primary-500/15 flex items-center justify-center">
        <i className="ri-copper-coin-line text-primary-400 text-sm"></i>
      </div>
      <div className="flex flex-col">
        <span className="text-xs font-semibold text-foreground-950 whitespace-nowrap">{name}</span>
        <span className="text-[10px] text-foreground-500">{code}</span>
      </div>
      <span className="text-sm font-bold text-foreground-950 whitespace-nowrap">
        {sell.toLocaleString('vi-VN')}đ
      </span>
      <span className={`text-xs font-semibold whitespace-nowrap ${isUp ? 'text-emerald-500' : 'text-rose-500'}`}>
        <i className={`${isUp ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} text-xs w-3 h-3 flex items-center justify-center inline-flex`}></i>
        {isUp ? '+' : ''}{changePercent.toFixed(2)}%
      </span>
      <span className="text-foreground-300 text-xs">•</span>
    </div>
  );
}

export default function GoldTicker() {
  const { data, loading, isMockData } = useVnGoldPrices();

  if (loading) {
    return (
      <div className="w-full border-b border-background-200/60 bg-background-100 py-2.5 overflow-hidden">
        <div className="flex items-center justify-center gap-2 text-xs text-foreground-500">
          <i className="ri-loader-4-line animate-spin"></i>
          Đang tải giá vàng...
        </div>
      </div>
    );
  }

  const items = data.slice(0, 8);
  if (items.length === 0) return null;

  return (
    <div className="w-full border-b border-background-200/60 bg-background-100 py-2.5 overflow-hidden relative">
      {isMockData && (
        <div className="absolute top-0.5 right-2 z-10 px-1.5 py-0.5 rounded bg-secondary-100/80 text-[10px] text-secondary-700 font-medium">
          <i className="ri-information-line mr-0.5"></i>
          Dữ liệu minh họa
        </div>
      )}
      <div className="flex animate-marquee whitespace-nowrap will-change-transform">
        {/* Duplicate để seamless loop */}
        {[...items, ...items].map((g, idx) => (
          <TickerItem
            key={`${g.type_code}-${idx}`}
            name={g.name}
            code={g.type_code}
            sell={g.sell}
            changePercent={g.change_percent}
          />
        ))}
      </div>
    </div>
  );
}